import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
export function ProblemSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full bg-white py-16 md:py-20" data-id="element-116">
      <div className="max-w-4xl mx-auto px-4 sm:px-6" data-id="element-117">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} data-id="element-118">
          <h2 className="font-fredoka text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 text-center mb-8" data-id="element-119">
            El problema que ningún padre quiere admitir...
          </h2>

          <div className="bg-red-50 border-l-4 border-red-400 p-6 sm:p-8 rounded-2xl mb-8" data-id="element-120">
            <p className="text-lg sm:text-xl text-gray-800 leading-relaxed mb-4" data-id="element-121">
              Tu hijo lleva 2 horas frente a la pantalla. Lo llamas a cenar y no
              responde. Le propones jugar y prefiere el celular.
            </p>
          </div>

          <div className="text-center space-y-6" data-id="element-122">
            <p className="text-xl sm:text-2xl font-nunito font-semibold text-gray-700" data-id="element-123">
              No es tu culpa. Las pantallas están diseñadas para ser adictivas.
            </p>

            <p className="text-xl sm:text-2xl font-nunito font-bold text-orange-600" data-id="element-124">
              Pero SÍ está en tus manos cambiarlo.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}